export default "__VITE_ASSET__RCaHVq_jCUoWDQWiWLxE3w__"